module.exports = __webpack_public_path__ + "double-division2-jp-mobile.jpg";